import { render } from "./TopPerformers.vue?vue&type=template&id=3ea96700"
import script from "./TopPerformers.vue?vue&type=script&lang=js"
export * from "./TopPerformers.vue?vue&type=script&lang=js"

import "./TopPerformers.vue?vue&type=style&index=0&id=3ea96700&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__